import { render, staticRenderFns } from "./ImageSelector.vue?vue&type=template&id=56847eaf"
import script from "./ImageSelector.vue?vue&type=script&lang=ts"
export * from "./ImageSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports